export const STORE_NAME = 'core/upload-media';
